import { Icon } from '@components/Icon';
import { FunctionComponent } from 'react';
import toast, {
  resolveValue,
  Toaster as RToaster,
  ToasterProps,
  ToastBar,
} from 'react-hot-toast';
import { ToastType } from 'react-hot-toast/dist/core/types';
import styled from 'styled-components';

interface StyledContentProps {
  toastType: ToastType;
}

export const DefaultNotificationConfig: ToasterProps = {
  position: 'bottom-right',
  reverseOrder: true,
  gutter: 8,
  toastOptions: {
    duration: 3000,
  },
};

const ColorMap: {
  [key in ToastType]: {
    background: string;
    color: string;
  };
} = {
  custom: { background: 'var(--primary-2)', color: 'var(--primary-5)' },
  blank: { background: 'var(--primary-2)', color: 'var(--primary-5)' },
  error: { background: 'var(--red-2)', color: 'var(--red-5)' },
  loading: { background: 'var(--primary-2)', color: 'var(--primary-5)' },
  success: { background: 'var(--green-2)', color: 'var(--green-5)' },
};

const StyledToastBar = styled(ToastBar)`
  box-shadow: none;
`;

const StyledContent = styled.div<StyledContentProps>`
  padding: 0.75rem;
  border-radius: 4px;
  width: 21.25rem;
  max-width: 21.25rem;
  border: 1px solid;
  display: flex;

  & > button {
    align-self: flex-start;
  }

  background-color: ${({ toastType }) => ColorMap[toastType]['background']};
  border-color: ${({ toastType }) => ColorMap[toastType]['color']};

  .notify-title {
    font-size: 1.0625rem;
    color: ${({ toastType }) => ColorMap[toastType]['color']};
    margin: 0;
  }
  .notify-content {
    font-size: 0.875rem;
    margin: 0.5rem 0 0;
  }
  .notify-messege-wrapper {
    flex: 1;
  }
  .notify-close-btn {
    border: 0;
    padding: 0;
    background: none;
    color: var(--grey-5);
    cursor: pointer;
    font-size: 1.25rem;

    &:hover {
      color: var(--grey-6);
    }
  }
`;

export const NotificationContainer: FunctionComponent<ToasterProps> = ({
  ...props
}) => (
  <RToaster {...DefaultNotificationConfig} {...props}>
    {(t) => {
      return (
        <StyledToastBar
          toast={t}
          style={{
            boxShadow: 'none',
            background: 'none',
            padding: 0,
          }}
        >
          {() => (
            <StyledContent toastType={t.type}>
              <div className="notify-messege-wrapper">
                {resolveValue(t.message, t)}
              </div>
              {t.type !== 'loading' && (
                <button
                  className="notify-close-btn"
                  onClick={() => toast.dismiss(t.id)}
                >
                  <Icon icon="circle-close-solid" />
                </button>
              )}
            </StyledContent>
          )}
        </StyledToastBar>
      );
    }}
  </RToaster>
);
